import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

export const generateDonation = async (data) => {
	try {
		const config = {
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
				'Content-Type': 'application/json'
			}
		}

		const response = await axios.post(`${API_URL}/users/donate/`, data, config);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 500) {
      		console.error("500 Internal Server Error");
			throw error;
    	} else {
			console.error("Error is:", error);
			throw error;
		}
	}
}


export const generateNPDonation = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${API_URL}/users/np-donate/`, data, config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Error is:", error);
      throw error;
    }
  }
};

export const generateNPSubscription = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${API_URL}/nonprofits/subscriptions/create/`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Error is:", error);
      throw error;
    }
  }
};
